module.exports = __webpack_public_path__ + "static/logo-c7c5b150488365abebfd908f08f20294.png";